// extracted by mini-css-extract-plugin
export default {"listContainer":"QuestionCardList_listContainer__rSDgX","list":"QuestionCardList_list__sUdVs"};